module.exports = __webpack_public_path__ + "img/will_being_read.d2628ca9.svg";